import { MessageMap, } from "openchat-shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class MessageLocalUpdates {
    deleted;
    editedContent;
    linkRemoved = false;
    cancelledReminder;
    undeletedContent;
    revealedContent;
    prizeClaimed;
    p2pSwapStatus;
    reactions = [];
    pollVotes = [];
    threadSummary;
    tips = new Map();
    hiddenMessageRevealed;
    blockLevelMarkdown;
    proposalTally;
    lastUpdated = 0;
}
export const messageLocalUpdates = writable(new MessageMap(), undefined, notEq);
